import { type FC, useState, useCallback } from 'react';
import styled, { useTheme } from 'styled-components';
import { ValidateOTPCard } from './components/ValidateOTPCard';
import { useZustandStore } from '../../appState/StoresProvider';
import { useOtpRequestExpiryHandling } from './hooks/useOtpRequestExpiryHandling';
import { Spinner } from '../Spinner/Spinner';
import { useAuthStore } from '../Login/useAuthStore';
import { WrongTenantError } from '../Login/wrongTenantError';

export const OneTimePassword: FC = () => {
  const resetOtpRequestInfo = useAuthStore((state) => state.resetOtpRequestInfo);
  const requestOTP = useAuthStore((state) => state.requestOTP);
  const signInWithOTP = useAuthStore((state) => state.signInWithOTP);
  const waiting = useZustandStore('auth', (v) => v.isFetching);
  const [error, setError] = useState<string | undefined>(undefined);
  const [buttonDisabled, _setButtonDisabled] = useState<boolean | undefined>(undefined);

  const otpRequestInfo = useOtpRequestInfo();
  const { normalizedTimeToExpiry, canResend } = useOtpRequestExpiryHandling();

  const handleBack = useCallback(() => {
    resetOtpRequestInfo();
  }, [resetOtpRequestInfo]);

  const handleResend = useCallback(() => {
    if (otpRequestInfo == null) {
      return;
    }
    setError(undefined);
    requestOTP(otpRequestInfo.username).then((_status) => {
      // if (!status.success) {
      //   setError(status.error);
      // }
    });
  }, [otpRequestInfo, requestOTP]);

  const handeSubmit = useCallback(
    (code: string) => {
      setError(undefined);

      /*
       * The rejection has to be handled here. Without a catch, a failed sign-in only reached the
       * console and the card sat there with no message and no way forward - which is what a
       * learner on the wrong tenant's URL saw, even though the code they typed was correct.
       */
      signInWithOTP(code).catch((caught: unknown) => {
        setError(
          caught instanceof WrongTenantError
            ? caught.message
            : "We couldn't sign you in with that code. Request a new one and try again.",
        );
      });
    },
    [signInWithOTP],
  );
  const theme = useTheme();

  return (
    <OTPContainer>
      {otpRequestInfo ? (
        <ValidateOTPCard
          email={otpRequestInfo.username}
          normalizedTimeToExpiry={normalizedTimeToExpiry}
          canResend={canResend}
          handleBack={handleBack}
          handleResend={handleResend}
          handleSubmit={handeSubmit}
          waiting={waiting}
          errorText={error}
          buttonDisabled={buttonDisabled}
        />
      ) : (
        <Spinner color={theme.colors.prototype.primary} size="48px" />
      )}
    </OTPContainer>
  );
};

const OTPContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100%;
  background: ${({ theme }) => theme.colors.prototype.background};
`;
function useOtpRequestInfo() {
  const otpRequestInfo = useAuthStore((state) => state.otpRequestInfo);

  // if (otpRequestInfo == null) {
  //   throw Error('No OTP request info available. This is unexpected');
  // }
  return otpRequestInfo;
}
